<script>
import Modal from "@/views/administration/substance/regulated-substances/regulated-properties/Modal.vue";
import {RegulatedPropertyType} from "@core/domain/substance";
import Button from "@core/components/common/Button.vue";
import MaterialCategorySelector
    from "@/views/administration/substance/regulated-substances/regulated-properties/MaterialCategorySelector.vue";
import MixtureCategorySelector
    from "@/views/administration/substance/regulated-substances/regulated-properties/MixtureCategorySelector.vue";
import HamletTable from "@core/components/common/HamletTable.vue";
import PropertyTable
    from "@/views/administration/substance/regulated-substances/regulated-properties/PropertyTable.vue";
// import GeneralProductStatementSelect from "@core/components/product/GeneralProductStatementSelect.vue";
import ProductCategorySelector
    from "@/views/administration/substance/regulated-substances/regulated-properties/ProductCategorySelector.vue";
import GeneralProductStatementSelect
    from "@/views/administration/substance/regulated-substances/regulated-properties/GeneralProductStatementSelect.vue";

export default {
    components: {
        HamletTable, Button, Modal, MaterialCategorySelector, MixtureCategorySelector, PropertyTable,
        GeneralProductStatementSelect, ProductCategorySelector
    },
    props: {
        properties: {
            type: Object,
        },
        list: {
            type: Object
        }
    },
    data() {
        return {
            propertyComponentMap: RegulatedPropertyType.selectorComponentMap(),
            selectedProperty: null,
            selectedPropertyValue: null,
            propertyInformation: RegulatedPropertyType.propertyInformation(),
            columns: [
                {
                    key: 'description',
                    label: this.$t('Component(Grid):column-covered-excluded'),
                },
                {
                    key: 'actions',
                    label: this.$t('Component(Grid):column-actions'),
                }
            ],
            config: null,
            fetchCallback: null,
        }
    },
    methods:{
        onChange(properties) {
            this.selectedPropertyValue = properties;
        },
        onPropertyValueSave() {
            this.$emit('change', this.list, this.selectedProperty, this.selectedPropertyValue.map(value => {
                if (!value.hasOwnProperty('coveredExcluded')) {
                    return {
                        property: value,
                        coveredExcluded: false
                    };
                }

                return value;
            }));
        },
        show() {
            this.$refs.modal.show();
            this.$nextTick(() => {
                this.fetch(this.config, this.fetchCallback);
            });
        },
        showSelector() {
            this.$refs.selector.show();
        },
        onTableCreated(config, cb, showLoader) {
            this.config = config;
            this.fetchCallback = cb;
        },
        fetch(config, cb) {
            const start = (config.page - 1) * config.perPage;

            cb(
                this.propertyInformation.length,
                this.propertyInformation.slice(start, start + config.perPage)
            );
        },
        linkProperty(property) {
            this.selectedProperty = property.property;
            this.showSelector();
        },
        removeProperty(property, propertyItem) {
            this.$emit('removePropertyItem', this.list, property, propertyItem);
        }
    },
    computed: {
        tableData() {
            return Object.keys(this.properties).map((property) => {
                return {
                    property: property,
                    rows: this.properties[property],
                    title: this.$t(RegulatedPropertyType.getTitle(property)),
                };
            });
        }
    }
}
</script>

<template>
    <div>
        <Modal
            ref="selector"
            @save="onPropertyValueSave"
        >
            <component
                v-if="propertyComponentMap.hasOwnProperty(selectedProperty)"
                :is="propertyComponentMap[selectedProperty]"
                @input="onChange"
                v-bind="{selected: properties[this.selectedProperty], multiple: true}"
            />
        </Modal>
        <PropertyTable
            v-for="propertyData in tableData"
            :properties="propertyData.rows"
            :title="propertyData.title"
            @add="() => linkProperty(propertyData)"
            @remove="(p) => removeProperty(propertyData, p)"
        />
    </div>
</template>
